import React from 'react';
import ReactDOM from 'react-dom/client';
import "./styles/globals.css"
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import client from "./apollo-client/graphql/client"
import 'react-phone-input-2/lib/style.css'
import { Toaster } from './components/ui/toaster';

const rootElement = document.getElementById('root');
rootElement.style.overflow = 'hidden';
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
          <Toaster />
        </BrowserRouter>
      </ApolloProvider>
    </React.StrictMode>
  );
}